export const ACCESS_ROLE_SUPER = "SUPER";
export const ACCESS_ROLE_ORG_ADMIN = "ORG_ADMIN";
export const ACCESS_ROLE_RECRUIT_ADMIN = "RECRUIT_ADMIN";
export const ACCESS_ROLE_HIRING_ADMIN = "HIRING_ADMIN";
export const ACCESS_ROLE_INTERVIEW_ADMIN = "INTERVIEW_ADMIN";
export const ACCESS_ROLE_SALES_ORG_ADMIN = "SALES_ORG_ADMIN";
export const ACCESS_ROLE_SALES_MANAGER = "SALES_MANAGER";
export const ACCESS_ROLE_CAMPAIGN_MANAGER = "CAMPAIGN_MANAGER";
export const ACCESS_ROLE_HIRING_CONTENT_ADMIN = "HIRING_CONTENT_ADMIN";
export const COMMUNITY_ACCESS_ROLE_LEAD = "LEAD";
export const COMMUNITY_ACCESS_ROLE_CUSTOMER = "CUSTOMER";
export const COMMUNITY_ACCESS_ROLE_TALENT = "TALENT";
